import React from "react";
import { RegisterUserRequest, useAuthDataContext } from "../../components/auth-provider";
import { Button, TextField, Typography } from "@material-ui/core";
import { useStyles } from "./LoginPage";


export const SignUpForm = () => {

  const classes = useStyles();

  const { onRegister, isLoading } = useAuthDataContext();

  const onFinish = (ev: any) => {

    ev.preventDefault();

    const { name, email, password } = ev.currentTarget.elements;

    var request: RegisterUserRequest = {
      name: name.value,
      email: email.value,
      password: password.value,
    };

    onRegister && onRegister(request);
  };

  return (
    <>
      <Typography component="h3" variant="h5">
        Crie sua conta
      </Typography>

      <form className={classes.form} noValidate onSubmit={onFinish}>

        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="name"
          label="Nome"
          name="nome"
          autoComplete="nome"
          autoFocus />

        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="email"
          label="E-mail"
          name="email"
          autoComplete="email" />

        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          name="password"
          label="Senha"
          type="password"
          id="password"
          autoComplete="current-password" />

        {isLoading === false && <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          className={classes.submit}
        >
          Criar Conta
          </Button>}

      </form>


    </>
  );
};
